const mutations = {
  idToken(state, idToken) {
    state.idToken = idToken
  },
}

export default mutations
